import React, { useCallback, useMemo } from 'react';
import { Breadcrumb, BreadcrumbItem, TabContent, TabPane } from 'reactstrap';
import classNames from 'classnames';
import NavCorporateTv from './_presenters/enum/navCorporateTv';
import MediaManagerListPage from 'pages/MediaManager/MediaManagerListPage';
import CampaignListPage from 'pages/Campaign/CampaignListPage';
import { useSearchParams } from 'react-router-dom';
import UrlExternalListPage from 'pages/Url/UrlExternalListPage/index';
import PlaylistListPage from 'pages/Playlist/PlaylistListPage';
import InternalsNewsListPage from 'pages/InternalsNews/InternalsNewsListPage';
import ExternalNewsListPage from 'pages/ExternalNews/ExternalNewsListPage';

const CorporateTv = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const setActiveTab = useCallback(
    (tab: NavCorporateTv) => setSearchParams({ tab }),
    [setSearchParams]
  );

  const activeTab = useMemo(
    () => searchParams.get('tab') || NavCorporateTv.CAMPAIGNS,
    [searchParams]
  );

  return (
    <div className="mx-3">
      <div>
        <Breadcrumb className="text-gray-600 fw-medium mt-4">
          <BreadcrumbItem>Tv Corporativa</BreadcrumbItem>
        </Breadcrumb>
        <h4 className="fw-bold mt-3">Tv Corporativa</h4>
        <span className="small-typography text-gray-600">
          Realize a gestão do conteúdo da sua TV Corporativa.
        </span>
        <div className="d-flex align-items-center mt-4">
          <div className="navlink">
            <div
              className={classNames('me-5 navlink', {
                active: activeTab === NavCorporateTv.CAMPAIGNS
              })}
              onClick={() => setActiveTab(NavCorporateTv.CAMPAIGNS)}
            >
              Campanhas
            </div>
          </div>
          <div className="navlink">
            <div
              className={classNames('me-5 navlink', {
                active: activeTab === NavCorporateTv.PLAYLISTS
              })}
              onClick={() => setActiveTab(NavCorporateTv.PLAYLISTS)}
            >
              Playlists
            </div>
          </div>
          <div className="navlink">
            <div
              className={classNames('me-5 navlink', {
                active: activeTab === NavCorporateTv.MEDIAS
              })}
              onClick={() => setActiveTab(NavCorporateTv.MEDIAS)}
            >
              Mídias
            </div>
          </div>
          <div className="navlink">
            <div
              className={classNames('me-5 navlink', {
                active: activeTab === NavCorporateTv.EXTERNAL_URL
              })}
              onClick={() => setActiveTab(NavCorporateTv.EXTERNAL_URL)}
            >
              URL Externa
            </div>
          </div>
          <div className="navlink">
            <div
              className={classNames('me-5 navlink', {
                active: activeTab === NavCorporateTv.INTERNAL_NEWS
              })}
              onClick={() => setActiveTab(NavCorporateTv.INTERNAL_NEWS)}
            >
              Noticias Internas
            </div>
          </div>
          <div className="navlink">
            <div
              className={classNames('navlink', {
                active: activeTab === NavCorporateTv.EXTERNAL_NEWS
              })}
              onClick={() => setActiveTab(NavCorporateTv.EXTERNAL_NEWS)}
            >
              Noticias Externas
            </div>
          </div>
        </div>
        <hr className="color-line" />
        <TabContent activeTab={activeTab}>
          <TabPane tabId={NavCorporateTv.CAMPAIGNS}>
            <div className="mt-3">
              <CampaignListPage />
            </div>
          </TabPane>
          <TabPane tabId={NavCorporateTv.PLAYLISTS}>
            <div className="mt-2">
              <PlaylistListPage />
            </div>
          </TabPane>
          <TabPane tabId={NavCorporateTv.MEDIAS}>
            <div>
              <MediaManagerListPage />
            </div>
          </TabPane>
          <TabPane tabId={NavCorporateTv.EXTERNAL_URL}>
            <div className="mt-2">
              <UrlExternalListPage />
            </div>
          </TabPane>
          <TabPane tabId={NavCorporateTv.INTERNAL_NEWS}>
            <div className="mt-2">
              <InternalsNewsListPage />
            </div>
          </TabPane>
          <TabPane tabId={NavCorporateTv.EXTERNAL_NEWS}>
            <div className="mt-2">
              <ExternalNewsListPage />
            </div>
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
};

export default CorporateTv;
